import { render } from "./VatTuKhoTable.vue?vue&type=template&id=ca0b900a&scoped=true&ts=true"
import script from "./VatTuKhoTable.vue?vue&type=script&lang=ts"
export * from "./VatTuKhoTable.vue?vue&type=script&lang=ts"

import "./VatTuKhoTable.vue?vue&type=style&index=0&id=ca0b900a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0b900a"]])

export default __exports__